import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-scroll";
import "../styles/Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isNavbarVisible, setNavbarVisible] = useState(true);
  const navbarRef = useRef(null);

  useEffect(() => {
    const footer = document.querySelector(".footer");

    const observer = new IntersectionObserver(
      ([entry]) => {
        setNavbarVisible(!entry.isIntersecting); // Hide navbar when footer is visible
      },
      { threshold: 0.1 } // Adjust threshold to determine when to toggle visibility
    );

    if (footer) {
      observer.observe(footer);
    }

    return () => {
      if (footer) {
        observer.unobserve(footer);
      }
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setMenuOpen(false); // Close the menu if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isNavbarVisible ? "" : "hidden"}`} ref={navbarRef}>
      <div className="navbar-container">
        <Link
          to="herosection"
          smooth={true}
          duration={500}
          className="navbar-brand"
          onClick={closeMenu}
        >
          <img
            className="navbar-logo"
            src={`${process.env.PUBLIC_URL}/images/of_logo.png`}
            alt="Orifril"
          />
          <span>Orifril Lifetech</span>
        </Link>

        {/* Hamburger Icon for Mobile */}
        <div className={`hamburger ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Links */}
        <div
          className={`navbar-overlay ${isMenuOpen ? "active" : ""}`}
          onClick={closeMenu}
        >
          <ul
            className={`navbar-links ${isMenuOpen ? "active" : ""}`}
            style={
              isMenuOpen
                ? { top: `${navbarRef.current?.offsetHeight || 50}px` } // Dynamic top calculation
                : {}
            }
          >
            <li>
              <Link
                to="herosection"
                smooth={true}
                duration={500}
                className="navbar-link"
                onClick={closeMenu}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="companyOverview"
                smooth={true}
                duration={500}
                offset={-navbarRef.current?.offsetHeight || -50}
                className="navbar-link"
                onClick={closeMenu}
              >
                Overview
              </Link>
            </li>
            <li>
              <Link
                to="directors"
                smooth={true}
                duration={500}
                offset={-20}
                className="navbar-link"
                onClick={closeMenu}
              >
                Directors
              </Link>
            </li>
            <li>
              <Link
                to="products"
                smooth={true}
                duration={500}
                offset={-30}
                className="navbar-link"
                onClick={closeMenu}
              >
                Products
              </Link>
            </li>
            <li>
              <Link
                to="contact"
                smooth={true}
                duration={500}
                className="navbar-link"
                onClick={closeMenu}
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
